import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getOilTicketShareList, downloadOilTicketShareList } from '@/api/bairun/ticket';
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import SearchTerm from '@/components/searchTerm';
import { mapGetters } from 'vuex';

var _this;

export default {
  name: 'OilTicketShareRecord',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    }
  },
  components: {
    SearchTerm: SearchTerm
  },
  mixins: [infoList],
  computed: _objectSpread({}, mapGetters('stations', ['allStationMap', 'allStations'])),
  data: function data() {
    return {
      listApi: getOilTicketShareList,
      loading: false,
      downloading: false,
      searchInfo: {
        // 按配置顺序显示
        'shareMobile': '',
        'ticketRuleNo': '',
        'shareTimeStart': '',
        'shareTimeEnd': ''
      },
      type: ''
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.onSearch();

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onSearch: function onSearch() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.page = 1;
                _this4.pageSize = 10;
                _this4.loading = true;
                _this4.searchInfo.ticketShareStatus = 1;
                _context4.next = 6;
                return _this4.getTableData();

              case 6:
                _this4.loading = false;

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onDownload: function onDownload() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.downloading = true;
                _this5.searchInfo.ticketShareStatus = 1;
                _context5.next = 4;
                return downloadOilTicketShareList(_this5.searchInfo);

              case 4:
                res = _context5.sent;

                if (res.code === 0) {
                  window.open(res.data.fileUrl);
                }

                _this5.downloading = false;

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  }
};